var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import DrawerHeader from "syf-component-library/ui/atoms/DrawerHeader";
import { Body } from "syf-component-library/ui/typography";
import DrawerHeaderWrapper from "./subcomponents";
import { useRewardsConfigContext } from "../../../../../context/rewardsConfig";
var ModalDrawerHeader = function (_a) {
    var _b, _c;
    var accountSummary = _a.accountSummary;
    var t = useTranslation().t;
    var config = useRewardsConfigContext().config;
    var defaultCardArt = "".concat(config.hosts.assets, "/assets/cardArt/syf_generic_card.svg");
    var title = accountSummary.product.displayName;
    var accountLast4 = accountSummary.accountInfo.accountLast4;
    return (_jsx(DrawerHeaderWrapper, __assign({ left: "base", top: "base", bottom: "medium", "data-test": "modal-drawer" }, { children: _jsx(DrawerHeader, { title: title, subtitle: _jsx(Body, { children: t("drawerHeader.subtitle.account", {
                    accountLast4: accountLast4,
                }) }), img: (_c = (_b = accountSummary.card) === null || _b === void 0 ? void 0 : _b.cardArtURL) !== null && _c !== void 0 ? _c : defaultCardArt, fallbackImage: defaultCardArt, alt: t("drawerHeader.subtitle.account") }) })));
};
export default ModalDrawerHeader;
